
<template>
<div class="address-content" @click="btnTap">
    <div class="address-icon v-center">
        <img class="address-icon-img" src="../../assets/image/mall-address.png" />
    </div>
    <div class="address-flex">
        <div class="address-details"  v-if="type == 2" style="margin-top:0;margin-bottom:0.1rem">凭取货码至</div>
        <div class="address-city">
            {{  address.provinceName || ''}}  {{ address.cityName  || ''}} {{address.regionName}}
            <!-- <div class="address-default">默认</div> -->
        </div>
        <div class="address-details">{{address.address}}</div>
        <div class="address-phone" v-if="type == 1">{{address.receiver || address.contacts}} {{address.phone || address.contactsPhone}}</div>
        <div class="address-phone" v-if="type == 2">联系人：{{address.receiver || address.contacts}} {{address.phone || address.contactsPhone}}</div>
    </div>
    <div class="v-center right-icon-box" v-if="isRightIcon">
        <img class="right-icon" src="../../assets/image/my-cell-icon-right.png" />
    </div>
</div>
</template>

<script>
export default {
  name: 'pi-order-address',
  data () {
    return {
      
    };
  },
  methods: {
    btnTap() {
      this.$emit('change')
    }
  },
  mounted () {

  },
  props:{
    address: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    type: {  // 1 是快递   2 自提
      type: Number,
      default: 1
    },
    isRightIcon: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less">
.address-content{
  display: flex;
  padding: 0.30rem 0.20rem;

  .address-icon{
    width: 0.74rem;
    text-align: center;
  }
  .address-icon-img{
    width: 0.54rem;
    height: 0.54rem;
  }
  .address-flex{
    flex: 1;
    font-size: 0.24rem;
    line-height: 0.33rem;
    color: #666;
  }
  .address-flex .address-default{
    display: inline-block;
    padding: 0.02rem 0.09rem;
    color: #14CC80;
    border: 0.01rem solid #14CC80;
    border-radius: 0.12rem;
    font-size: 0.18rem;
    line-height: 0.25rem;
    margin-left: 0.20rem;
    font-weight: 500;
  }
  .address-phone{
    margin-top: 0.10rem;
  }
  .address-details{
    margin-top: 0.10rem;
    font-size: 0.28rem;
    line-height: 0.40rem;
    color: #000;
  }
  .right-icon-box{
    padding-left: 0.47rem;
  }
  .right-icon{
    width: 0.16rem;
    height: 0.28rem;
  }
  .address-content.address-no-box{
    justify-content: center;
    align-items: center;
  }
  .address-no-box .address-no-icon{
    width: 1.50rem;
    height: 0.97rem;
    display: block;
  }
  .address-no-box  .add-address{
    text-align: center;
  }
  .address-no-box .add-address-btn{
    padding: 0.03rem 0.10rem;
    font-size: 0.18rem;
    line-height: 0.25rem; 
    background: linear-gradient(180deg, #2DE8B7 0%, #14CC80 100%);
    border-radius: 0.30rem;
    color: #fff;
    display: inline-block;
    margin-top: 0.30rem;

  }
  .v-center {
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
  }
}
</style>
